import * as React from 'react';
import { useState } from 'react';
import styled from 'styled-components';

import DropDownView from './views/DropDownView';
import Suggestion from './Suggestion';
import Field from './Field';

import { SNOW_SEARCH_FIELD_FOCUSED } from './events';
import { SearchContext, ISuggestionList, ISuggestion, ILabel, ISnowSearchPlacement } from './types';

const FieldKeywordView = styled.div`
  position: relative;
`;

interface IProps {
  searchContext: SearchContext;
  placement: ISnowSearchPlacement;
  placeholder?: string;
  isDropDownShown: boolean;
  selectedSuggestion?: ISuggestion;
  suggestionList: ISuggestionList;
  labelHidden: boolean;
  handleChange: (event: React.ChangeEvent) => void;
}

const FieldKeyword: React.FC<IProps> = (props) => {
  const { searchContext, placement, placeholder, isDropDownShown,
    selectedSuggestion, suggestionList, labelHidden, handleChange } = props;

  function handleClick(event: React.MouseEvent) {
    const detail = { focusedField: 'keyword', placement };
    const clickEvent = new CustomEvent(SNOW_SEARCH_FIELD_FOCUSED, { detail });
    document.dispatchEvent(clickEvent);
    // Allow user to type right after clicking
    Array.from(event.currentTarget.children).forEach((element) => {
      if (element.tagName === 'INPUT') {
        const input = (element as HTMLInputElement);
        input.focus();
        input.value = input.value;
      }
    })
  }

  function fieldLabel(): ILabel {
    const label = { main: '' };
    if (selectedSuggestion) {
      label.main = selectedSuggestion.label;
    }
    return label;
  }

  return (
    <FieldKeywordView>
      <Field
        icon="search"
        placeholder={placeholder}
        label={fieldLabel()}
        labelHidden={labelHidden}
        handleClick={handleClick}
        handleChange={handleChange} />
      {isDropDownShown && Object.values(suggestionList).some(list => list.length > 0) &&
        <DropDownView>
          <div style={{ maxHeight: 400, overflowY: 'scroll' }}>
            {Object.values(suggestionList).map(list => (
              list.map((sug: ISuggestion) => (
                <Suggestion
                  key={`${sug.type}-${sug.id}`} {...sug}
                  searchContext={searchContext}
                  placement={placement} />
              ))
            ))}
          </div>
        </DropDownView>}
    </FieldKeywordView>
  );
}

export default FieldKeyword;
